<template>
<v-container fluid >
  <v-form ref="form">
    <TextField 
      :loading="any_loading"
      :label="`${$t('Срок хранения .log файлов в днях.')}`"
      :hint="$t('.log файлы страше указанного количества дней будут автоматически удалены.')"
      :rules="[rules.inrange(1, 30)]"
      type="number"

      :original_value="config.retention_days"
      v-model="local_config.retention_days"
    />
    
    <TextField 
      :loading="any_loading"
      :label="`${$t('Уровень логирования (значения больше 5 могут привести к быстрому росту .log файлов)')}`"
      :hint="`${$t('Управляет подробностью .log файлов')}
      ${$t('0 - Только критические ошибки')}
      ${$t('1 - информация о обработанных исправимых ошибках')}
      ${$t('2 - Предупреждения')}
      ${$t('3,4 - Уведомления об успешном окончании операций')}
      ${$t('5 - Шаги алгоритмов')}
      ${$t('6,7 - Шаги алгоритмов с источником записи')}
      ${$t('8,9 - Листинги запросов и ответов, стэки вызовов при форматировани ошибок')}
      ${$t('10 - Подробнейшая отладочная информация')}
      `"
      :rules="[rules.inrange(0, 10)]"
      type="number"

      :original_value="config.level"
      v-model="local_config.level"
    />
  </v-form>
</v-container>
</template>

<script>
import TextField from '../../common/TextField.vue'
import settings_group_mixin from '../settings_group_mixin'
// import SelectField from '../../common/SelectField.vue'

export default {
  mixins: [settings_group_mixin],
  data: () => ({
    local_loading: false,
    locales: [],

  }),
  computed: {
    any_loading() {
      return this.local_loading || this.local_loading
    }
  },
  methods: {
    async loadLocales(){
      this.local_loading = true
      try {
        this.locales = await this.$store.dispatch('getAvailableLocales')
      } finally {
        this.local_loading = false
      }
    },
    validate(){
      if (!this.$refs.form.validate()) {
        throw new Error(this.$t('Проверьте корректность веденных настроек перед сохранением изменений'))
      }
    }
  },
  mounted(){
    this.loadLocales()
  },
  components: {
    TextField,
    // SelectField
  }
}
</script>